import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  CircularProgress,
  Button,
  Container,
  Chip
} from '@mui/material';
import { Link } from 'react-router-dom';

const SportsNewsPage = () => {
  const [sportsStories, setSportsStories] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const fetchSportsStories = async () => {
      try {
        const response = await fetch('https://ethioinsider-backend.onrender.com/api/articles/sports');
        if (!response.ok) {
          throw new Error('Failed to fetch sports stories');
        }
        const result = await response.json();
        if (result.data && Array.isArray(result.data)) {
          setSportsStories(result.data);
        } else {
          throw new Error('Unexpected API response format');
        }
      } catch (err) {
        setError(err.message);
        console.error('Fetch error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSportsStories();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4, mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography variant="body1" color="error" sx={{ textAlign: "center", py: 4, mt: 10 }}>
        Error loading sports stories: {error}
      </Typography>
    );
  }

  if (sportsStories.length === 0) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ textAlign: "center", py: 4, mt: 10 }}>
        No sports stories available at the moment.
      </Typography>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4, mt: 10 }}>
      <Typography variant="h3" component="h1" gutterBottom sx={{ mb: 4 }}>
        Sports News
      </Typography>
      
      <Grid container spacing={3}>
        {sportsStories.map((story) => (
          <Grid xs={12} sm={6} md={4} key={`sports-${story._id}`}>
            <Card square elevation={1}>
              <CardActionArea 
                component={Link}
                to={`/article/${story._id}`}
                sx={{ height: "100%" }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={story?.imageUrl || "https://via.placeholder.com/400x250?text=Sports"}
                  alt={story?.title}
                  sx={{ objectFit: "cover" }}
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/400x250?text=Sports";
                  }}
                />
                <CardContent>
                  <Chip label="Sports" color="primary" size="small" sx={{ mb: 1 }} />
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    sx={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      minHeight: "3em"
                    }}
                  >
                    {story?.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden"
                    }}
                  >
                    {story?.excerpt || "No excerpt available"}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                    {new Date(story?.createdAt).toLocaleDateString()}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default SportsNewsPage;